/**
 * Defines the visibility scope of catalog items.
 */
export enum CatalogScope {
  /**
   * User-scoped: Private to the creator, visible only to them.
   */
  User = 'user',

  /**
   * Global-scoped: Visible to all users across the system.
   */
  Global = 'global'
}

/**
 * Filter mode for catalog item queries.
 */
export enum CatalogFilterMode {
  /**
   * Show only items created by the current user.
   */
  MyItems = 'MyItems',

  /**
   * Show only global items (visible to all users).
   */
  GlobalItems = 'GlobalItems',

  /**
   * Show both user items and global items (default).
   */
  AllItems = 'AllItems'
}
